import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user-highlight",
  "use": "icon-user-highlight-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-user-highlight\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.1691 8.18182C15.1691 9.93818 13.7564 11.3636 12 11.3636C10.2436 11.3636 8.81818 9.93818 8.81818 8.18182C8.81818 6.42545 10.2436 5 12 5C13.7564 5 15.1691 6.42545 15.1691 8.18182ZM5 16.4091C5 14.08 9.67091 12.9091 12 12.9091C14.3291 12.9091 19 14.08 19 16.4091V19.2727H5V16.4091Z\" fill=\"#0052CC\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol